export default __webpack_public_path__ + "static/jamie@2x-9d9c1147593c07e7e0db44afe3921bc8.png";